import styled from 'styled-components';

export const StyledPageDescTooltip = styled.div`
  max-height: 200px;
  overflow: auto;
  scrollbar-width: thin;
  ul {
    padding: 0px 20px;
    font-weight: 400;
    strong {
      font-weight: 600;
    }
  }
`;
